import { makeStyles, Text } from '@fluentui/react-components';
import React from 'react';
import { Link, useNavigate } from 'react-router';
import { useUserSettings } from '../../../contexts/useUserSettings';
import { Report } from '../../../model';
import { customPalette } from '../../../theme';
import { VIEW_REPORT_URL } from '../../../utils/Urls.constant';

interface ReportLinkProps {
    report: Report;
    tabIndex?: number;
}

const useStyles = makeStyles({
    link: {
        textDecoration: 'none',
        ':hover': {
            textDecoration: 'underline',
            textDecorationColor: customPalette.themePrimary,
            cursor: 'pointer',
        },
        '& > span:hover': {
            color: customPalette.themePrimary,
        },
    },
    reportName: {
        color: customPalette.blueDark,
        whiteSpace: 'nowrap',
        fontSize: '14px',
        lineHeight: '24px',
        fontWeight: 600,
    },
});

const ReportLink: React.FC<ReportLinkProps> = ({ report, tabIndex = 0 }) => {
    const navigate = useNavigate();
    const userSettingsContext = useUserSettings();
    const styles = useStyles();

    return (
        <Link
            role='link'
            to={VIEW_REPORT_URL + report.id}
            onClick={() => openReport()}
            className={styles.link}
            tabIndex={tabIndex}
            data-analytics-button-name='report_link'
        >
            <Text className={styles.reportName}>{report.name ?? ''}</Text>
        </Link>
    );

    function openReport(): void {
        userSettingsContext.updateReturnTabs(
            {
                returnKey: report.id ?? 0,
                returnName: report.name ?? '',
            },
            true
        );
        return navigate(VIEW_REPORT_URL + report.id);
    }
};

export { ReportLink as default };
